import "./index.css";

const Footer = () => {
    return (
        <div className="footer">
            <a href="/resume/timothy_liakh_resume.pdf" target="_blank" rel="noopener noreferrer">
                View Resume 📝
            </a>
        </div>
    );
};

export default Footer;
